import validate from "/usr/src/app/content/n3-packages-21da3772-dac0-4fe6-afd0-94f026c048e9/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-21da3772-dac0-4fe6-afd0-94f026c048e9/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}